import { cloneDeep, noop } from 'lodash';
import { COL_ELEMENT_IS_BLOCK } from '@/utils/common-kit';
import { ITableLayer } from '@/version-types';
import renderTempTableLayer from './render-temp-table-layer';
import { getUpdatedTableStyle, GetUpdatedTableStyle_Action } from './table';

/**
 * 部分场景需要修复表格数据 ———— 部分浏览器无法直接计算数据, 需要通过dom去获取最新数据; 从外部解析出来的表格数据布局大概率是错乱的 (比如xlsx解析为表格的时候, 解析出来的baseCells的值是不准确的)
 * 当COL_ELEMENT_IS_BLOCK为false时, 不会修复baseCells.horizontal(因为没办法修复), 但只要tableLayer.width还在且baseCells.horizontal有值, 展示就不会有大问题, 因为table元素会按照baseCells.horizontal的比例自动撑开
 */
const fixTableLayout = async <T extends ITableLayer | ITableLayer<true>>({
    originalLayer,
    stageScale,
    originalLayerIsReliable = false,
    action = noop,
}: {
    originalLayer: T;
    stageScale: number;
    /** originalLayer是否可靠, 如果可靠, 且修复出的新布局与旧布局相近时, 则不进行修复. 这是为了防止精度问题导致的布局抖动 */
    originalLayerIsReliable?: boolean;
    action?: GetUpdatedTableStyle_Action;
}): Promise<T> => {
    const newLayer = cloneDeep(originalLayer);
    await renderTempTableLayer({
        stageScale,
        layer: originalLayer,
        task: (containerEl) => {
            const newInfo = getUpdatedTableStyle({
                tableEl: containerEl.querySelector('table')!,
                stageScale,
                tableRotate: originalLayer.rotate,
                action,
                compute: (_, { getLayout }) =>
                    originalLayerIsReliable
                        ? getLayout({
                              tableWidth: originalLayer.width,
                              tableHeight: originalLayer.height,
                              horizontalSizes: originalLayer.data.baseCells.horizontal,
                              verticalSizes: originalLayer.data.baseCells.vertical,
                          })
                        : getLayout(),
            })!;
            // 当COL_ELEMENT_IS_BLOCK为false时, 没法修复baseCells.horizontal
            if (COL_ELEMENT_IS_BLOCK) {
                newLayer.data.baseCells.horizontal = newInfo.baseCells.horizontal;
            }
            newLayer.data.baseCells.vertical = newInfo.baseCells.vertical;
            newLayer.width = newInfo.tableWidth;
            newLayer.height = newInfo.tableHeight;
        },
    });
    return newLayer;
};

export default fixTableLayout;
